// Shared Framer Motion presets — module-level constants avoid re-created
// inline objects on every render.
export const FADE_UP = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.4 },
};

export const FADE_IN = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { duration: 0.4 },
};

export const EASE_OUT = [0.22, 1, 0.36, 1];
